/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：82
 */

"use strict"

export { IconWidgetButton as g }
export { B8DFFF as a }
export { i as o }
export { a as l }
export { s as h }
export { c as p }
export { l as m }
export { u as n }
export { d as k }
export { p as r }
export { f as q }
export { h as j }
export { m as i }
export { SansSerif as b }
export { _32383E as e }
export { _32383E1 as d }
export { Https__static$bcmcdn$com_coco_image_defaultButtonBackground$png as f }
export { y as c }
var /* [auto-meaningful-name] */IconWidgetButton = "icon-widget-button"
var /* [auto-meaningful-name] */B8DFFF = "#B8DFFF"
var i = 12
var a = 80
var s = 60
var c = 36
var l = 360
var u = 36
var d = 360
var p = 12
var f = 8
var h = 20
var m = 12
var /* [auto-meaningful-name] */SansSerif = "sans-serif"
var /* [auto-meaningful-name] */_32383E = "#32383E"
var /* [auto-meaningful-name] */_32383E1 = "#32383E"
var /* [auto-meaningful-name] */Https__static$bcmcdn$com_coco_image_defaultButtonBackground$png = "https://static.bcmcdn.com/coco/image/default-button-background.png"
var y = {
  id: "button_widget_default_icon",
  md5: "",
  name: "收藏",
  cdnUrl: "https://ocean.codemao.cn/appcraft/resource/icon/社交/收藏.svg",
  source: ""
}
export default B8DFFF
